import { useTranslation } from "react-i18next";
import RoleManagementPage from "./RoleManagementPage";
import {
  ADMIN_COUNTRY_MANAGERS,
  ADMIN_COUNTRY_MANAGER_REQUESTS,
  APPROVE_COUNTRY_MANAGER_REQUEST,
  REJECT_COUNTRY_MANAGER_REQUEST,
} from "@/api/services/adminservice";

export default function CountryManager() {
  const { t } = useTranslation();
  return (
    <RoleManagementPage
      entityLabel={t('admin.countryManager.entityLabel', 'Country Manager')}
      totalLabel={t('admin.countryManager.totalLabel', 'Total Country Managers')}
      requestLabel={t('admin.countryManager.requestLabel', 'Country Manager Requests')}
      requestDescription={t('admin.countryManager.requestDescription', 'Operators who have requested to become country managers.')}
      searchPlaceholder={t('admin.countryManager.searchPlaceholder', 'Search country managers or requests...')}
      inviteRole="country-manager"
      entityDescription={t('admin.countryManager.entityDescription', 'All country managers fetched from the admin country managers list.')}
      ownerColumnLabel={t('admin.countryManager.ownerColumnLabel', 'Country')}
      dateColumnLabel={t('admin.countryManager.dateColumnLabel', 'Became Country Manager At')}
      emptyEntitiesLabel={t('admin.countryManager.emptyEntitiesLabel', 'No country managers found.')}
      emptyRequestsLabel={t('admin.countryManager.emptyRequestsLabel', 'No operator country manager requests found.')}
      enableEntityFilters
      countryPlaceholder={t('admin.countryManager.countryPlaceholder', 'Filter by country code, e.g. NG')}
      themeKey="countryManager"
      entityIcon="globe"
      listEntities={ADMIN_COUNTRY_MANAGERS}
      listRequests={ADMIN_COUNTRY_MANAGER_REQUESTS}
      rejectEntity={REJECT_COUNTRY_MANAGER_REQUEST}
      approveRequest={APPROVE_COUNTRY_MANAGER_REQUEST}
    />
  );
}
